import { html } from 'lit';
import moment from 'moment/moment';
import { CustomRulesEvents, RuleType } from '../types';
import { translateFn } from '../../../utils/translator.helper';
import { Rights } from '@nirvana/shared/constants';

export function renderRuleName(rule, component, company, isPartner, availableCompanies, asEditLink: boolean = true) {
  if (!asEditLink || !Application.Main.hasAllRights([Rights.RIGHT_MANAGE_INVENTORY, Rights.MANAGE_POLICIES_WRITE])) {
    return rule.name;
  }
  const ruleNameButton = createRuleNameButton(rule, component);

  return rule.canEdit ? ruleNameButton : rule.name;
}

function createRuleNameButton(rule, component) {
  return html`
    <gz-button
      type="quiet"
      lowercase
      color="primary"
      theme="light"
      buttonheight="small"
      buttonfontsize="small"
      class="accent cell-label inline-text"
      style="cursor: pointer;--small-button-font-size: var(--body-size); width: auto;"
      @click="${() => {
    const event = new CustomEvent(CustomRulesEvents.EDIT, {
      detail: { rule },
      bubbles: true,
      composed: true,
    });
    component.dispatchEvent(event);
  }}"
    >${rule.name}
    </gz-button>`;
}

export function renderTags(rule) {
  return renderCellLabel(!rule.tags || rule.tags.length === 0 ? '-' : rule.tags.join(', '));
}

export function renderCreatedOn(rule) {
  return renderCellLabel(moment(rule.created).format('DD MMM YYYY, HH:mm'));
}

export function renderLastUpdatedOn(rule) {
  return renderCellLabel(moment(rule.lastModified).format('DD MMM YYYY, HH:mm'));
}

export function renderRuleType(rule) {
  return renderCellLabel(rule.type === RuleType.YARA ? translateFn('YARA') : translateFn('Basic'));
}

export function renderCompanyName(rule) {
  let text: string;
  if (!rule.targets.companies) {
    text = translateFn('None');
  } else {
    const companies = new Set(rule.targets.companies.map(item => item.name));
    text = Array.from(companies).join(', ');
  }
  return renderCellLabel(text);
}

function renderCellLabel(text: string) {
  return html`<span class="cell-label"> ${text} </span>`;
}
